import React, { useEffect } from 'react';

interface Props {
	value: any;
	id?: string;
}

const DisplayDataStructure: React.FC<Props> = ({ value, id: propId }) => {
	const id = propId || 'display-data-structure-slot';

	useEffect(() => {
		// @ts-ignore This is a third-party library loaded as a script tag through CDN in index.html and available as a global object
		new JsonViewer({
			value: value,
		}).render('#' + id);
	}, [value]);

	return <div id={id}></div>;
};

export default DisplayDataStructure;
